import React from 'react';
import { Link } from 'react-router-dom';

function InstallGuide() {
  // Detect the user's operating system and browser
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);
  // eslint-disable-next-line no-unused-vars
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isChrome = /Chrome/.test(navigator.userAgent) && !/Edge/.test(navigator.userAgent);
  const isFirefox = /Firefox/.test(navigator.userAgent);
  const isEdge = /Edge/.test(navigator.userAgent);

  return (
    <div className="install-guide">
      <h1 className="form-title">Install Invoice App on Your Device</h1>
      
      <div className="install-card">
        <h2 className="form-section-title">Why Install?</h2>
        <ul className="install-list">
          <li>Use the app offline</li>
          <li>Faster loading times</li>
          <li>App icon on your home screen or desktop</li>
          <li>Full-screen experience without browser controls</li>
          <li>Automatic updates</li>
        </ul>
      </div>

      {/* Show instructions based on detected device/browser */}
      {isIOS && (
        <div className="install-card">
          <h2 className="form-section-title">Install on iOS</h2>
          <ol className="install-list">
            <li>Open the app in Safari (other browsers on iOS don't support PWA installation)</li>
            <li>Tap the Share button <span className="install-step-badge">↑</span> at the bottom of the screen</li>
            <li>Scroll down and tap "Add to Home Screen"</li>
            <li>Name the app and tap "Add"</li>
            <li>The app will now appear on your home screen</li>
          </ol>
        </div>
      )}

      {isAndroid && (
        <div className="install-card">
          <h2 className="form-section-title">Install on Android</h2>
          <ol className="install-list">
            <li>Open the app in Chrome</li>
            <li>Tap the menu button (three dots) in the top-right corner</li>
            <li>Tap "Install app" or "Add to Home Screen"</li>
            <li>Follow the on-screen prompts</li>
            <li>The app will now appear on your home screen</li>
          </ol>
        </div>
      )}

      {!isIOS && !isAndroid && (
        <div className="install-card">
          <h2 className="form-section-title">Install on Desktop</h2>
          
          {isChrome && (
            <div className="install-subsection">
              <h3 className="install-subtitle">Chrome</h3>
              <ol className="install-list">
                <li>Look for the install icon (➕) in the address bar</li>
                <li>Click the install button and follow the prompts</li>
                <li>The app will install and can be launched from your desktop</li>
              </ol>
            </div>
          )}
          
          {isEdge && (
            <div className="install-subsection">
              <h3 className="install-subtitle">Edge</h3>
              <ol className="install-list">
                <li>Look for the install icon (➕) in the address bar</li>
                <li>Click the install button and follow the prompts</li>
                <li>The app will install and can be launched from your desktop</li>
              </ol>
            </div>
          )}
          
          {isFirefox && (
            <div className="install-subsection">
              <h3 className="install-subtitle">Firefox</h3>
              <ol className="install-list">
                <li>Look for the home icon with a plus sign in the address bar</li>
                <li>Click the icon and then "Install"</li>
                <li>The app will install and can be launched from your desktop</li>
              </ol>
            </div>
          )}
          
          <div className="install-subsection">
            <h3 className="install-subtitle">Manual Installation</h3>
            <ol className="install-list">
              <li>Open the application in Chrome or Edge</li>
              <li>Click the three dots menu in the top-right corner</li>
              <li>Select "Install Invoice App" or "Apps" &gt; "Install this site as an app"</li>
              <li>Follow the on-screen prompts to complete installation</li>
            </ol>
          </div>
        </div>
      )}
      
      {!isIOS && !isAndroid && isSafari && (
        <div className="install-card">
          <h2 className="form-section-title">Install on Desktop Safari</h2>
          <p className="install-text">Safari on desktop doesn't fully support PWA installation. For the best experience, we recommend using Chrome, Edge, or Firefox.</p>
        </div>
      )}
      
      <div className="install-card">
        <h2 className="form-section-title">Having Trouble?</h2>
        <p className="install-text">If you're having trouble installing the app:</p>
        <ul className="install-list">
          <li>Make sure you're using a supported browser (Chrome, Safari, Edge, or Firefox)</li>
          <li>Check that you have a stable internet connection for the initial installation</li>
          <li>Try refreshing the page and attempting installation again</li>
          <li>Clear your browser cache and cookies, then try again</li>
        </ul>
      </div>
      
      <div className="install-back">
        <Link to="/" className="auth-link">
          ← Return to Dashboard
        </Link>
      </div>
    </div>
  );
}

export default InstallGuide;